  import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
import { TransitionGroup } from 'react-transition-group';
import { MessageBarTransition } from './MessageBarTransition';
/**
 * Render the final JSX of MessageBarGroup
 */ export const renderMessageBarGroup_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ _jsx(state.root, {
        children: /*#__PURE__*/ _jsx(TransitionGroup, {
            component: null,
            children: state.children.map((child)=>/*#__PURE__*/ _jsx(MessageBarTransition, {
                    animate: state.animate,
                    enterClassName: state.enterStyles,
                    exitClassName: state.exitStyles,
                    children: child
                }, child.key))
        })
    });
};
